import React from 'react';
import PropTypes from 'prop-types';
import HubsSportsField from '../../../../components/HubsSportsField';
import HubsEntityCollection from '../../../../components/HubsEntityCollection';

export const EntityComponent = ({ entity, handleChange, order, collection }) => {
  const entityData = collection.editor.getEntity(entity.eid, 'he_sport_name');
  return (
    <React.Fragment>
      <HubsSportsField
        nameField={entityData.getField('he_sport_name')}
        mensAssocField={entityData.getField('he_assocmen_id')}
        mensDivField={entityData.getField('he_divmen_id')}
        mensConfField={entityData.getField('he_confmen_id')}
        initialValue={entity}
        onChange={(e, value) => handleChange(e, {
          value: value.value,
          order,
          name: value.fieldName,
        }, null, order)}
      />
    </React.Fragment>
  );
};

EntityComponent.propTypes = {
  entity: PropTypes.object,
  handleChange: PropTypes.func,
  order: PropTypes.number,
  collection: PropTypes.object,
};

const Athletics = ({ onChange, ...props }) => (
  <HubsEntityCollection
    {...props}
    disableRemove
    nonUnique
    _key="he_sport_name"
  >
    <EntityComponent handleChange={onChange} />
  </HubsEntityCollection>
);

Athletics.propTypes = {
  initialValue: PropTypes.array,
  onChange: PropTypes.func,
  mapper: PropTypes.object,
};

export default Athletics;
